/**
 * The version list an office editor reads: the drive's route natively, the share
 * session's own route in the share view (same `{ versions }` shape — the version-history
 * right, an Edit link or native access, is enforced there; a View link gets 403).
 */
export function officeVersionsPath(fileId: string, shareView?: boolean): string {
  return shareView ? `/api/wopi/versions/${fileId}` : `/api/files/${fileId}/versions`
}
